import React, {useEffect} from 'react';
import {Col, Container, Row} from 'reactstrap';
import {DateTime} from 'luxon';
import {useUserState} from 'contexts/user';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faLock, faCartPlus} from '@fortawesome/pro-light-svg-icons';
import ABTest, {DebugMenu} from 'react-controlled-ab';
import {subscribeToCampaign} from 'react-controlled-ab/datalayers/vwo';
import {usePhaseState} from 'funnel-schedule/phase-context';
import track from 'utils/track';

import PageMeta from 'components/PageMeta';
import Video from 'components/Video';
import CheckoutButton from 'components/CheckoutButton';
import SalesCopy from 'components/SalesCopy';
import {SalesCtaImpactDynamic} from 'components/SalesCta';
import Footer from 'components/Footer';
import ShareButtons from 'components/ShareButtons';
import ModalExitSales from 'components/ModalExitSales';
import cc from 'static/payments-accepted.png';

export default function Impact({
  salesFlag = '',
  salesCta = <SalesCtaImpactDynamic trees />,
  noExitIntent = false,
  ...props
}) {
  const userState = useUserState();
  const {email, registrationId} = useUserState();
  useEffect(() => {
    const {HS_BEACON_ID} = process.env;
    if (!HS_BEACON_ID || !window.Beacon) return;
    window.Beacon('init', HS_BEACON_ID);
    return () => {
      window.Beacon('destroy');
    };
  }, []);
  const {
    phases: {webinar: {phase: schedulePhase = undefined, time = DateTime.utc().toSeconds()} = {}} = {},
    userStateLoaded = false
  } = usePhaseState();

  const isCartClose = DateTime.fromSeconds(time, {zone: 'utc'}).plus({days: 4}) < DateTime.utc();
  const phase = props.phase ? props.phase : schedulePhase;
  let videoUrl = userStateLoaded
    ? salesFlag !== ''
      ? {
          sales67: 'https://www.youtube.com/watch?v=bxLgVFvNVw8',
          sales97: 'https://www.youtube.com/watch?v=bxLgVFvNVw8'
        }[salesFlag]
      : phase === 'replay'
      ? isCartClose
        ? 'https://www.youtube.com/watch?v=l7Mq3WgOs2I'
        : 'https://www.youtube.com/watch?v=bxLgVFvNVw8'
      : 'https://www.youtube.com/watch?v=fx4TCCF5Y_Q'
    : null;

  const salesFullPrice = (!email && !registrationId && !salesFlag) || (!salesFlag && phase === 'after');

  useEffect(() => {
    track('Product Viewed', {
      product_id: 'tntg',
      sku: 'tntg',
      name: 'TNTG Impact Kit',
      variant: !salesFullPrice ? 'tntg-impactkit-launch-wlc-30daytrial-st' : 'tntg-impactkit-wlc-30daytrial-st',
      value: !salesFullPrice ? 97 : 197,
      currency: 'usd'
    });
  }, [salesFullPrice]);

  return (
    <div className="page d-flex flex-column">
      <PageMeta />

      <div className="page-content">
        <div className="background-gradient-yellow-white">
          <div className="background-black triangle-bottom triangle-bottom-black text-white text-center wrapper">
            <div className="offset-header-during">
              <Container>
                <Row className="d-flex justify-content-center">
                  <Col xs="12" sm="10" md="9" lg="12">
                    <h2 className="text-condensed text-800 mb-0">
                      Can we count on you to <br className="d-none d-lg-block d-xl-none" />
                      be part of the SOLUTION?
                    </h2>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
          <div className="video-box offset-video-box-during">
            <Container>
              <Row>
                <Col className="px-0 px-sm-3">
                  {videoUrl ? <Video url={videoUrl} label="TNTG - Sales Video - Impact" /> : null}
                </Col>
              </Row>
            </Container>
          </div>

          <div className="pt-5 triangle-angles-offset-bottom text-center">
            <Container>
              <Row>
                <Col>
                  <h2 className="text-condensed text-800 mb-0">
                    Get inspired and <em>stay</em> <br className="d-none d-sm-block d-md-none" />
                    that way <br className="d-none d-xl-block" />
                    with <br className="d-none d-lg-block d-xl-none" />
                    <em>The Need To GROW</em> Impact Kit
                  </h2>
                  <Row className="d-flex justify-content-center">
                    <Col xs="12" lg="8" className="my-4">
                      <img src="https://cdn.foodrevolution.org/tntg/tntg-productimage-digitalall.png" />
                    </Col>
                  </Row>

                  {phase === 'replay' || salesFlag ? (
                    <>
                      {salesFlag ? (
                        <>
                          {salesFlag === 'sales67' ? (
                            <>
                              <h2 className="text-condensed text-green text-800">Your Special Offer: $67</h2>
                              <CheckoutButton
                                className="offer-box-button"
                                sku="tntg"
                                price="67"
                                slug="tntg-impactkit-special-wlc-30daytrial-st"
                              >
                                <FontAwesomeIcon className="mr-2" icon={faCartPlus} /> Buy Now
                              </CheckoutButton>
                            </>
                          ) : null}
                          {salesFlag === 'sales97' ? (
                            <>
                              <h2 className="text-condensed text-green text-800">Your Special Offer: $97</h2>
                              <CheckoutButton
                                className="offer-box-button"
                                sku="tntg"
                                price="97"
                                slug="tntg-impactkit-launch-wlc-30daytrial-st"
                              >
                                <FontAwesomeIcon className="mr-2" icon={faCartPlus} /> Buy Now
                              </CheckoutButton>

                              {props.specialSalesTimer}
                            </>
                          ) : null}
                        </>
                      ) : (
                        <>
                          <h4 className="text-400 mb-2">
                            Regular Price: <del>$197</del>
                          </h4>
                          <h2 className="text-condensed text-green text-800">Limited Time Discount Price: $97</h2>
                          <CheckoutButton
                            className="offer-box-button"
                            sku="tntg"
                            price="97"
                            slug="tntg-impactkit-launch-wlc-30daytrial-st"
                          >
                            <FontAwesomeIcon className="mr-2" icon={faCartPlus} /> Buy Now
                          </CheckoutButton>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <h2 className="text-condensed text-green text-800">Your Price: $197</h2>
                      <CheckoutButton
                        className="offer-box-button"
                        sku="tntg"
                        price="197"
                        slug="tntg-impactkit-wlc-30daytrial-st"
                      >
                        <FontAwesomeIcon className="mr-2" icon={faCartPlus} /> Buy Now
                      </CheckoutButton>
                    </>
                  )}
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="offer-box-details">
                    <div className="offer-box-cards">
                      <img className="img-fluid img-cc" src={cc} />
                    </div>
                    <div className="offer-box-security">
                      <FontAwesomeIcon className="offer-box-security-icon mr-2" icon={faLock} />
                      For your security, all orders are processed on a secured server.
                    </div>
                    <div className="offer-box-protected d-flex justify-content-center">
                      Your purchase is protected by our 60-day money back guarantee.
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        <SalesCopy salesTestimonials salesCta={salesCta} />
      </div>

      <div className="mt-auto">
        <Footer />
        <ShareButtons floating />
      </div>

      {noExitIntent ? null : <ModalExitSales />}
    </div>
  );
}
